import { useState } from 'react'

import { Box, Container } from '@material-ui/core'
import { PageTitle } from '@scoir/headers'
import useTitle from 'common/use-title'

import RequirementSection from './RequirementSection'
import AppRoundSection from './AppRoundSection'
import AppRoundProvider from './AppRoundProvider'
import RoundRequirementsProvider from './RoundRequirementsProvider'
import AppRoundMessaging from './AppRoundMessaging'
import { useConfigureUpcomingApplicationCycle } from 'store/feature-toggle/hooks'
import { useAppCycle, useRoundConfigurationAppCycle } from 'store/application-cycle/hooks'
import CopyCurrentRoundsAlert from 'routes/application/AppCycleRounds/CopyCurrentRoundsAlert.tsx'
import CurrentUpcomingAppCycleToggle from 'routes/application/CurrentUpcomingAppCycleToggle.tsx'

const AppCycleRounds = () => {
  useTitle('Scoir - Set Rounds')

  const isConfigureUpcomingEnabled = useConfigureUpcomingApplicationCycle()
  const currentAppCycle = useAppCycle()
  const upcomingCycle = useRoundConfigurationAppCycle()
  const defaultCycle = isConfigureUpcomingEnabled ? upcomingCycle : currentAppCycle
  const [applicationCycle, setApplicationCycle] = useState<number>(defaultCycle)
  const [isCurrent, setHasCurrentFocus] = useState(isConfigureUpcomingEnabled ? false : true)

  return (
    <RoundRequirementsProvider applicationCycle={applicationCycle}>
      <AppRoundProvider applicationCycle={applicationCycle}>
        <Box my={4}>
          <Container maxWidth="lg">
            <PageTitle
              title="Set Rounds"
              actions={
                isConfigureUpcomingEnabled && (
                  <CurrentUpcomingAppCycleToggle
                    hasCurrentFocus={isCurrent}
                    onChangeCycleFocus={(isFocused) => {
                      setHasCurrentFocus(isFocused)
                      setApplicationCycle(isFocused ? currentAppCycle : upcomingCycle)
                    }}
                  />
                )
              }
            />
            <Box mb={2}>
              <CopyCurrentRoundsAlert />
            </Box>
            <AppRoundMessaging isCurrent={isCurrent} />
            <Box mb={2}>
              <RequirementSection />
            </Box>
            <Box my={2}>
              <AppRoundSection />
            </Box>
          </Container>
        </Box>
      </AppRoundProvider>
    </RoundRequirementsProvider>
  )
}

export default AppCycleRounds
